import { useMutation, useQueryClient } from '@tanstack/react-query';
import { sourcesApi } from '../api/sources.api';
import type { UpdateSourceRequest } from '../types/sources.types';
import { sourceKeys } from './queryKeys';
import { Notification } from '@/shared/components/ahkinia/Notification/notification';

export const useEditSource = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateSourceRequest }) =>
      sourcesApi.updateSource(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: sourceKeys.all });

      Notification.success({
        title: 'Fuente actualizada',
        description:
          'La fuente ha sido actualizada exitosamente. La sincronización se reprogramará según la nueva configuración.',
      });
    },
  });
};
